import React from "react";
import { Text, StackProps } from "@chakra-ui/react";

import { Module } from "@constants";
import {
  GetCollectionResp,
  PaginationOpts,
  SearchCollection,
  useCollectionSearch,
} from "@hooks";
import { SearchMarkup } from "./SearchMarkup";
import { ButtonModal } from "../ModalWrappers";

type DbSearchProps<T> = {
  collection: SearchCollection;
  resultsCallback: (resp: GetCollectionResp<T>) => void;
  helpText?: React.ReactNode;
  paginationOpts?: PaginationOpts;
} & StackProps;

export function DbSearch<T extends Module>({
  collection,
  resultsCallback,
  helpText = null,
  paginationOpts,
  ...delegated
}: DbSearchProps<T>) {
  const [queryString, setQueryString] = React.useState("");
  const [queryError, setError] = React.useState("");

  const searchData = useCollectionSearch<T>(
    collection,
    queryString,
    paginationOpts,
  );

  React.useEffect(() => {
    resultsCallback(searchData);
    if (searchData.documents !== undefined && searchData.documents.length !== 0)
      setError("");
  }, [searchData]);
  return (
    <>
      <SearchMarkup
        search={(query: string) => {
          setError("");
          setQueryString(query);
        }}
        {...delegated}
      >
        {helpText ? (
          <ButtonModal variant="ghost" size="lg" title="Search Help" label="?">
            {helpText}
          </ButtonModal>
        ) : undefined}
      </SearchMarkup>
      {queryError !== "" ? <Text>{queryError}</Text> : undefined}
    </>
  );
}
